import { useTranslation } from "react-i18next";
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  RadioGroupProps,
  Typography,
} from "@material-ui/core";
import { ZipPasswordType } from "pages/Rules/Form/context/reducers/changeZipPasswordType";
import { useRuleContext } from "pages/Rules/Form/context/ruleContext";

export default function ZipPasswordTypeSelect() {
  const { t } = useTranslation("rules");
  const { state, dispatch } = useRuleContext();
  const { passwordPerRecipient } = state.rule?.zipAttachments;
  const type = passwordPerRecipient ? "INDIVIDUAL" : "SAME";

  const onChange: RadioGroupProps["onChange"] = event => {
    dispatch({
      type: "changeZipPasswordType",
      payload: event.target.value as ZipPasswordType,
    });
  };

  return (
    <RadioGroup style={{ marginBottom: 24 }} value={type} onChange={onChange}>
      <FormControlLabel
        value="SAME"
        control={<Radio color="primary" size="small" />}
        label={
          <Typography variant="caption" style={{ fontSize: 14 }}>
            {t("zipPasswordType.same")}
          </Typography>
        }
      />
      <FormControlLabel
        value="INDIVIDUAL"
        control={<Radio color="primary" size="small" />}
        label={
          <Typography variant="caption" style={{ fontSize: 14 }}>
            {t("zipPasswordType.individual")}
          </Typography>
        }
      />
    </RadioGroup>
  );
}
